import { deserialize } from 'cerialize'
import { XOR } from 'Helpers'
import { TagModel } from 'Pages/admin'
import { CommentModel } from 'Pages/knowledge'

export enum KindTypeModel {
	TEXT = 'text',
	VIDEO = 'video',
}

export enum ArticleStateTypeModel {
	DRAFT = 'draft',
	PUBLISHED = 'published',
}

export const enum ArticleDeleteState {
	RECOVER = 'recover',
	DELETE = 'delete',
}

export class ArticleModel {
	@deserialize public id?: number
	@deserialize public attachments?: File
	@deserialize public editable_by_current_user?: boolean
	@deserialize public created_at?: string
	@deserialize public external_url?: string
	@deserialize public html?: string
	@deserialize public kind?: KindTypeModel
	@deserialize public name?: string
	@deserialize public position?: number
	@deserialize public project?: { id: number; name: string; slug: string }
	@deserialize public s3_file_name?: string
	@deserialize public slug?: string
	@deserialize public state?: ArticleStateTypeModel
	@deserialize public table_of_contents?: boolean
	@deserialize public tags?: TagModel[]
	@deserialize public updated_at?: string
	@deserialize public views_count?: number
	@deserialize public viewed_by_user?: boolean
	@deserialize public deleted_at?: string

	@deserialize public is_public?: boolean
	@deserialize public files?: Map<string, XOR<{ url: string; blob: Blob }, File>>
	@deserialize public tags_attributes?: TagModel[]
	@deserialize public video_file?: File
	@deserialize public denied_show_role_ids?: number[]
	@deserialize public edit_user_ids?: number[]
	@deserialize public query?: string
	@deserialize public comment?: string
	@deserialize public comments?: CommentModel[]
}
